import React from "react";
import { DataTable } from "../widgets";
import { toDisplayDateTimeString } from "../../helpers/moment-ex";
import { formatNumber, Unit } from "../../helpers/unit";

const PickedListRow = (props) => {
  const { load, serialNumber } = props;
  const unit = Unit.getInstance();

  return (
    <DataTable.Row>
      <DataTable.Cell>{serialNumber}</DataTable.Cell>
      <DataTable.Cell>{load.transload_geo_region_name}</DataTable.Cell>
      <DataTable.Cell>{load.transport_equipment_group_name}</DataTable.Cell>
      <DataTable.Cell>{load.transport_operator_name}</DataTable.Cell>
      <DataTable.Cell>{load.transport_equipment_name}</DataTable.Cell>
      <DataTable.Cell>
        {formatNumber(unit.toFixedOf(load.load_capacity))}
      </DataTable.Cell>
      <DataTable.Cell>
        {toDisplayDateTimeString(load.load_trip_date_tz, false, false)}
      </DataTable.Cell>
      <DataTable.Cell>{load.source_equipment_group_name}</DataTable.Cell>
      <DataTable.Cell>{load.target_equipment_group_name}</DataTable.Cell>
      <DataTable.Cell>
        {load.load_date_tz
          ? toDisplayDateTimeString(load.load_date_tz, false, false)
          : null}
      </DataTable.Cell>

      <DataTable.Cell>
        {load.load_status ? (
          <span className="badge badge-pill badge-success badge-sm">
            Processed
          </span>
        ) : (
          <span className="badge badge-pill badge-warning badge-sm">
            Pending
          </span>
        )}
      </DataTable.Cell>
    </DataTable.Row>
  );
};

export default PickedListRow;